// src/taskpane/features/integrations/components/dartsip/JurisprudenceList.tsx

import React from 'react';
import { FileSearch } from 'lucide-react';
import { JurisprudenceCase } from '../../types/integrationTypes';
import JurisprudenceCard from './JurisprudenceCard';

interface JurisprudenceListProps {
  cases: JurisprudenceCase[];
  isLoading: boolean;
  onAddToKnowledgeBase: (case_id: string) => void;
  onViewDocument: (case_id: string) => void;
  addingCaseId?: string;
}

const JurisprudenceList: React.FC<JurisprudenceListProps> = ({ 
  cases, 
  isLoading,
  onAddToKnowledgeBase,
  onViewDocument,
  addingCaseId
}) => {
  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <div className="relative">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-muted"></div>
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-primary absolute top-0 left-0"></div>
        </div>
        <p className="text-sm text-muted-foreground mt-3">Buscando jurisprudencia...</p>
      </div>
    );
  }

  if (cases.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <div className="bg-muted rounded-full p-3 mb-3">
          <FileSearch className="w-8 h-8 text-muted-foreground" />
        </div>
        <h3 className="text-sm font-semibold text-foreground mb-1">
          No se encontraron resultados
        </h3>
        <p className="text-xs text-muted-foreground max-w-xs">
          Intenta ajustar los filtros de búsqueda para encontrar casos relevantes
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {cases.map((case_data) => (
        <JurisprudenceCard 
          key={case_data.case_id} 
          case_data={case_data}
          onAddToKnowledgeBase={onAddToKnowledgeBase}
          onViewDocument={onViewDocument}
          isAdding={addingCaseId === case_data.case_id}
        />
      ))}
    </div>
  );
};

export default JurisprudenceList;

